export default __webpack_public_path__ + "static/media/bird3.ce4c0ef1.svg";